/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Resource Explorer Service API
 * OpenAPI spec version: 0.1.0
 */
import type {HttpContext, HttpEvent, HttpParams} from '@angular/common/http';
import {HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders} from '@angular/common/http';

import {Injectable, inject} from '@angular/core';

import {Observable} from 'rxjs';

import {APP_ENVIRONMENT} from '@app/core/tokens/app-environment.token';
import {type AppEnvironment} from '@models/environment';

import type {
  AutocompleteParams,
  BuildIndexParams,
  DatasetSearchSchema,
  DeleteDatasetInIndexParams,
  DeleteProjectInIndexParams,
  GlobalSearchSchema,
  IndexSearchResponse,
  ProjectSearchSchema,
  ResourceSearchSchema,
  SearchDatasetsInIndexParams,
  SearchProjectsAndDatasetsInIndexParams,
  SearchProjectsInIndexParams,
  SearchResourcesInIndex200One,
  SearchResourcesInIndexParams,
  SyncDatasetInIndexBody,
  SyncDatasetInIndexParams,
  SyncProjectInIndexBody,
  SyncProjectInIndexParams,
} from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (
      value != null &&
      (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}

export type SearchResourcesInIndexAccept =
  (typeof SearchResourcesInIndexAccept)[keyof typeof SearchResourcesInIndexAccept];

export const SearchResourcesInIndexAccept = {
  application_json: 'application/json',
  text_csv: 'text/csv',
} as const;

@Injectable({providedIn: 'root'})
export class IndexService {
  public http = inject(HttpClient);
  _environment: AppEnvironment = inject(APP_ENVIRONMENT);
  _baseUrl: string | undefined = undefined;

  get baseUrl(): string {
    return this._baseUrl ?? this._environment.api;
  }

  set baseUrl(newUrl: string) {
    this._baseUrl = newUrl;
  }

  /**
   * Get autocomplete suggestions given a term and record type.
   * @summary Autocomplete
   */
  autocomplete<TData = string[]>(params: AutocompleteParams, options?: HttpClientBodyOptions): Observable<TData>;
  autocomplete<TData = string[]>(
    params: AutocompleteParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  autocomplete<TData = string[]>(
    params: AutocompleteParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  autocomplete<TData = string[]>(
    params: AutocompleteParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/api/index/autocomplete`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/api/index/autocomplete`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/api/index/autocomplete`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * @summary Build Resource Explorer Or Data Enclave Indices
   */
  buildIndex<TData = boolean>(params: BuildIndexParams, options?: HttpClientBodyOptions): Observable<TData>;
  buildIndex<TData = boolean>(params: BuildIndexParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  buildIndex<TData = boolean>(
    params: BuildIndexParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  buildIndex<TData = boolean>(
    params: BuildIndexParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/build`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/build`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/api/index/build`, undefined, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Search for datasets, requires authentication if public_view is False.
   * @summary Search Datasets
   */
  searchDatasetsInIndex<TData = IndexSearchResponse>(
    datasetSearchSchema: DatasetSearchSchema,
    params: SearchDatasetsInIndexParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  searchDatasetsInIndex<TData = IndexSearchResponse>(
    datasetSearchSchema: DatasetSearchSchema,
    params: SearchDatasetsInIndexParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  searchDatasetsInIndex<TData = IndexSearchResponse>(
    datasetSearchSchema: DatasetSearchSchema,
    params: SearchDatasetsInIndexParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  searchDatasetsInIndex<TData = IndexSearchResponse>(
    datasetSearchSchema: DatasetSearchSchema,
    params: SearchDatasetsInIndexParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/search/datasets`, datasetSearchSchema, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/search/datasets`, datasetSearchSchema, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/api/index/search/datasets`, datasetSearchSchema, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Search for projects, requires authentication if public_view is False.
   * @summary Search Projects
   */
  searchProjectsInIndex<TData = IndexSearchResponse>(
    projectSearchSchema: ProjectSearchSchema,
    params: SearchProjectsInIndexParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  searchProjectsInIndex<TData = IndexSearchResponse>(
    projectSearchSchema: ProjectSearchSchema,
    params: SearchProjectsInIndexParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  searchProjectsInIndex<TData = IndexSearchResponse>(
    projectSearchSchema: ProjectSearchSchema,
    params: SearchProjectsInIndexParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  searchProjectsInIndex<TData = IndexSearchResponse>(
    projectSearchSchema: ProjectSearchSchema,
    params: SearchProjectsInIndexParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/search/projects`, projectSearchSchema, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/search/projects`, projectSearchSchema, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/api/index/search/projects`, projectSearchSchema, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Search for project and datasets, requires authentication if public_view is False.
   * Note: This is a global search across all fields in both projects and datasets.
   * @summary Search Projects And Datasets
   */
  searchProjectsAndDatasetsInIndex<TData = IndexSearchResponse>(
    globalSearchSchema: GlobalSearchSchema,
    params: SearchProjectsAndDatasetsInIndexParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  searchProjectsAndDatasetsInIndex<TData = IndexSearchResponse>(
    globalSearchSchema: GlobalSearchSchema,
    params: SearchProjectsAndDatasetsInIndexParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  searchProjectsAndDatasetsInIndex<TData = IndexSearchResponse>(
    globalSearchSchema: GlobalSearchSchema,
    params: SearchProjectsAndDatasetsInIndexParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  searchProjectsAndDatasetsInIndex<TData = IndexSearchResponse>(
    globalSearchSchema: GlobalSearchSchema,
    params: SearchProjectsAndDatasetsInIndexParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/search/projects-and-datasets`, globalSearchSchema, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/search/projects-and-datasets`, globalSearchSchema, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/api/index/search/projects-and-datasets`, globalSearchSchema, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Searches for resources, requires authentication if public_view is False. Returns results as a .csv file if
   * csv_export is True.
   * @summary Search Resources
   */
  searchResourcesInIndex(
    params: SearchResourcesInIndexParams,
    resourceSearchSchema: ResourceSearchSchema,
    accept: 'application/json',
    options?: HttpClientOptions,
  ): Observable<SearchResourcesInIndex200One>;
  searchResourcesInIndex(
    params: SearchResourcesInIndexParams,
    resourceSearchSchema: ResourceSearchSchema,
    accept: 'text/csv',
    options?: HttpClientOptions,
  ): Observable<string>;
  searchResourcesInIndex(
    params: SearchResourcesInIndexParams,
    resourceSearchSchema: ResourceSearchSchema,
    accept?: SearchResourcesInIndexAccept,
    options?: HttpClientOptions,
  ): Observable<SearchResourcesInIndex200One | string>;
  searchResourcesInIndex(
    params: SearchResourcesInIndexParams,
    resourceSearchSchema: ResourceSearchSchema,
    accept: SearchResourcesInIndexAccept = 'application/json',
    options?: HttpClientOptions,
  ): Observable<SearchResourcesInIndex200One | string> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    const headers =
      options?.headers instanceof HttpHeaders
        ? options.headers.set('Accept', accept)
        : {...(options?.headers ?? {}), Accept: accept};

    if (accept.includes('json') || accept.includes('+json')) {
      return this.http.post<SearchResourcesInIndex200One>(
        `${this.baseUrl}/api/index/search/resources`,
        resourceSearchSchema,
        {
          ...options,
          responseType: 'json',
          headers,
          params: filteredParams,
        },
      );
    } else if (accept.startsWith('text/') || accept.includes('xml')) {
      return this.http.post(`${this.baseUrl}/api/index/search/resources`, resourceSearchSchema, {
        ...options,
        responseType: 'text',
        headers,
        params: filteredParams,
      }) as Observable<any>;
    }

    return this.http.post<SearchResourcesInIndex200One>(
      `${this.baseUrl}/api/index/search/resources`,
      resourceSearchSchema,
      {
        ...options,
        responseType: 'json',
        headers,
        params: filteredParams,
      },
    );
  }
  /**
   * Queues a sync of all projects and datasets currently accessible to the user.
   * @summary Sync Accessible Records For Current User
   */
  syncAccessibleRecordsForCurrentUser<TData = unknown>(options?: HttpClientBodyOptions): Observable<TData>;
  syncAccessibleRecordsForCurrentUser<TData = unknown>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  syncAccessibleRecordsForCurrentUser<TData = unknown>(
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  syncAccessibleRecordsForCurrentUser<TData = unknown>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/sync/accessible-records`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/sync/accessible-records`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/api/index/sync/accessible-records`, undefined, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * This endpoint is used to delete a data enclave dataset (retrieved from the data enclave using the
   * `storage_organization` name) in ES. NOTE: This endpoint should only be used for when a dataset is IMMEDIATELY deleted, rather
   * than when it is scheduled for deletion (in the case of a scheduled deletion, use the POST dataset sync endpoint).
   * @summary Sync Delete Dataset In Index
   */
  deleteDatasetInIndex<TData = unknown>(
    datasetId: string,
    params: DeleteDatasetInIndexParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  deleteDatasetInIndex<TData = unknown>(
    datasetId: string,
    params: DeleteDatasetInIndexParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  deleteDatasetInIndex<TData = unknown>(
    datasetId: string,
    params: DeleteDatasetInIndexParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  deleteDatasetInIndex<TData = unknown>(
    datasetId: string,
    params: DeleteDatasetInIndexParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.delete<TData>(`${this.baseUrl}/api/index/sync/datasets/${datasetId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(`${this.baseUrl}/api/index/sync/datasets/${datasetId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.delete<TData>(`${this.baseUrl}/api/index/sync/datasets/${datasetId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * This endpoint is used to sync a data enclave dataset (retrieved from the data enclave using the
   * `storage_organization` name) with ES. This also initiates the PI File Size limit check, HIPAA Alert check, Dataverse
   *  metadata upload, and REDCap token request.
   * @summary Sync Update Dataset In Index
   */
  syncDatasetInIndex<TData = boolean>(
    datasetId: string,
    params: SyncDatasetInIndexParams,
    syncDatasetInIndexBody?: SyncDatasetInIndexBody,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  syncDatasetInIndex<TData = boolean>(
    datasetId: string,
    params: SyncDatasetInIndexParams,
    syncDatasetInIndexBody?: SyncDatasetInIndexBody,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  syncDatasetInIndex<TData = boolean>(
    datasetId: string,
    params: SyncDatasetInIndexParams,
    syncDatasetInIndexBody?: SyncDatasetInIndexBody,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  syncDatasetInIndex<TData = boolean>(
    datasetId: string,
    params: SyncDatasetInIndexParams,
    syncDatasetInIndexBody?: SyncDatasetInIndexBody,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/sync/datasets/${datasetId}`, syncDatasetInIndexBody, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/sync/datasets/${datasetId}`, syncDatasetInIndexBody, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/api/index/sync/datasets/${datasetId}`, syncDatasetInIndexBody, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * This endpoint is used to delete a data enclave project (retrieved from data enclave using the
   * `storage_organization` name) in ES. NOTE: This endpoint should only be used for when a project is IMMEDIATELY deleted, rather
   * than when it is scheduled for deletion (in the case of a scheduled deletion, use the POST project sync endpoint).
   * @summary Sync Delete Project In Index
   */
  deleteProjectInIndex<TData = unknown>(
    projectId: string,
    params: DeleteProjectInIndexParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  deleteProjectInIndex<TData = unknown>(
    projectId: string,
    params: DeleteProjectInIndexParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  deleteProjectInIndex<TData = unknown>(
    projectId: string,
    params: DeleteProjectInIndexParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  deleteProjectInIndex<TData = unknown>(
    projectId: string,
    params: DeleteProjectInIndexParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.delete<TData>(`${this.baseUrl}/api/index/sync/projects/${projectId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(`${this.baseUrl}/api/index/sync/projects/${projectId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.delete<TData>(`${this.baseUrl}/api/index/sync/projects/${projectId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * This endpoint is used to sync a data enclave project (retrieved from data enclave using the
   * `storage_organization` name) with ES. This also initiates the PI File Size limit check
   * @summary Sync Update Project In Index
   */
  syncProjectInIndex<TData = boolean>(
    projectId: string,
    params: SyncProjectInIndexParams,
    syncProjectInIndexBody?: SyncProjectInIndexBody,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  syncProjectInIndex<TData = boolean>(
    projectId: string,
    params: SyncProjectInIndexParams,
    syncProjectInIndexBody?: SyncProjectInIndexBody,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  syncProjectInIndex<TData = boolean>(
    projectId: string,
    params: SyncProjectInIndexParams,
    syncProjectInIndexBody?: SyncProjectInIndexBody,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  syncProjectInIndex<TData = boolean>(
    projectId: string,
    params: SyncProjectInIndexParams,
    syncProjectInIndexBody?: SyncProjectInIndexBody,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/sync/projects/${projectId}`, syncProjectInIndexBody, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/api/index/sync/projects/${projectId}`, syncProjectInIndexBody, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/api/index/sync/projects/${projectId}`, syncProjectInIndexBody, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
}
